import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  inject,
} from '@angular/core';

@Directive({
  selector: '[mytcTitleOnOverflow]',
  standalone: true,
})
export class TitleOnOverflowDirective implements AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly cd = inject(ChangeDetectorRef);

  @Input() mytcTitleOnOverflow: string;

  @HostBinding('attr.title') title = '';

  @HostListener('window:resize') onResize(): void {
    this.setTitle();
  }

  ngAfterViewInit(): void {
    this.setTitle();
    this.cd.detectChanges();
  }

  private setTitle(): void {
    const { nativeElement } = this.el;

    if (
      'scrollWidth' in nativeElement &&
      'offsetWidth' in nativeElement &&
      nativeElement.scrollWidth > nativeElement.offsetWidth
    ) {
      this.title = this.mytcTitleOnOverflow;
    } else {
      this.title = '';
    }
  }
}
